module.exports = __webpack_public_path__ + "static/carbonit-300ab3da9d87385c3e80bccaefceec0f.png";